/** Source rectangle (sx,sy,sw,sh) and destination rectangle to draw an iw x ih image into a w x h cell at (x,y). */
export function placeInCell(iw: number, ih: number, x: number, y: number, w: number, h: number, fit: boolean) {
  if (!fit) {
    // fill: scale up until the cell is covered, crop the overflow, centered
    const scale = Math.max(w / iw, h / ih);
    const sw = w / scale, sh = h / scale;
    return { sx: (iw - sw) / 2, sy: (ih - sh) / 2, sw, sh, dx: x, dy: y, dw: w, dh: h };
  }
  // fit: the whole photo is visible, centered, the rest of the cell shows the background
  const scale = Math.min(w / iw, h / ih);
  const dw = iw * scale, dh = ih * scale;
  return { sx: 0, sy: 0, sw: iw, sh: ih, dx: x + (w - dw) / 2, dy: y + (h - dh) / 2, dw, dh };
}
